import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../../../shared/context/auth-context";
import { dadosImpressao } from "../../../../../../shared/util/dadosImpressao";
import { podeAlterarRegisto } from "../../../../../../shared/util/unidadeRegisto";
import BadgeUnidade from "../../../../../../shared/components/badgeUnidade/BadgeUnidade";
import SeloSoConsulta from "../../../../../../shared/components/badgeUnidade/SeloSoConsulta";
import { Link } from "react-router-dom";
import "../List.scss";

//mui - manter os componentes da tabela
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
//lucide-react para ícones
import {
  Trash2,
  Check,
  Eye,
  FileText,
  Edit3,
  PlusCircle,
  Replace,
  RefreshCw,
  Copy,
  XCircle,
  ClipboardCheck,
  Send,
} from "lucide-react";
//Antd
import { Popover } from "antd";
import { Popconfirm } from "antd";
import { format, differenceInDays } from "date-fns";

import { abreviarNome } from "../../../../../../shared/util/helperFunctions";
import ModalSubstituicaoOrcamento from "../../../../../orcamentos/components/modalSubstituicaoOrcamento/ModalSubstituicaoOrcamento";

function List(props) {
  const auth = useContext(AuthContext);

  // Um orçamento é um compromisso comercial da unidade onde foi feito: fora
  // dela é só de leitura. Ver, gerar PDF e duplicar continuam disponíveis —
  // duplicar cria um orçamento NOVO, que nasce na unidade da sessão.
  const podeAlterarOrcamento = (row) =>
    podeAlterarRegisto(row?.estabelecimento, auth);
  const navigate = useNavigate();
  const [modalSubstituicaoOpen, setModalSubstituicaoOpen] = useState(false);
  const [orcamentoSelecionado, setOrcamentoSelecionado] = useState(null);

  const handleAbrirSubstituicao = (orcamentoId) => {
    const orcamento = props.data.find((orc) => orc.id === orcamentoId);
    setOrcamentoSelecionado(orcamento);
    setModalSubstituicaoOpen(true);
  };

  const handleFecharSubstituicao = () => {
    setModalSubstituicaoOpen(false);
    setOrcamentoSelecionado(null);
  };

  const verOrcamento = (id, tipo) => {
    const filteredOrcamento = props.data.filter((orc) => {
      return orc.id === id;
    })[0];

    const pdfServiceList = [];
    //Para orcamento particular
    if (tipo === "Particular") {
      if (filteredOrcamento.beneficio === "Particular") {
        //Se o beneficio for particular, todos os procedimentos terão preço particular
        filteredOrcamento.procedimentos.forEach((proc) => {
          pdfServiceList.push({
            tratamento: proc.tratamento,
            dente: proc.dente,
            faces: proc.faces.join(","),
            valor_cliente: proc.valor_cliente,
          });
        });
      } else {
        if (filteredOrcamento.instituicaoCobertura?.nome) {
          filteredOrcamento.procedimentos.forEach((proc) => {
            if (proc.valor_cobertura === 0) {
              pdfServiceList.push({
                tratamento: proc.tratamento,
                dente: proc.dente,
                faces: proc.faces.join(","),
                valor_cliente: proc.valor_cliente,
              });
            }
          });
        }
      }
    } else if (tipo === "SEGURADO") {
      //Para orcamento beneficiario
      filteredOrcamento.procedimentos.forEach((proc) => {
        if (proc.valor_cobertura > 0) {
          pdfServiceList.push({
            tratamento: proc.tratamento,
            dente: proc.dente,
            faces: proc.faces.join(","),
            valor_cobertura: proc.valor_cobertura,
            valor_cliente: proc.valor_cliente,
            preco_segurado: proc.preco_segurado,
            preco_beneficiario: proc.preco_beneficiario || 0,
          });
        }
      });
    } else if (tipo === "Misto") {
      //Para orcamento beneficiario
      filteredOrcamento.procedimentos.forEach((proc) => {
        pdfServiceList.push({
          tratamento: proc.tratamento,
          dente: proc.dente,
          faces: proc.faces.join(","),
          valor_cobertura: proc.valor_cobertura,
          valor_cliente: proc.valor_cliente,
          preco_segurado: proc.preco_segurado,
          preco_beneficiario: proc.preco_beneficiario || 0,
        });
      });
    }
    props.orcamentoData(
      tipo,
      filteredOrcamento.instituicaoCobertura?.nome || "Instituição",
      pdfServiceList,
      filteredOrcamento.cliente,
      // Morada e contactos da UNIDADE onde o orçamento foi feito, não da que
      // está a imprimir. Sem unidade (clínicas de unidade única, ou orçamentos
      // anteriores à migração) devolve a clínica tal e qual.
      dadosImpressao(props.clinica, filteredOrcamento.estabelecimento),
      filteredOrcamento.medico_responsavel,
      filteredOrcamento.numero,
      filteredOrcamento.desconto,
      filteredOrcamento.tipoDesconto,
      filteredOrcamento.orcamentoMisto,
      filteredOrcamento.created_at,
      filteredOrcamento.transformado,
      filteredOrcamento.aprovadoPor?.data,
      filteredOrcamento.modalidadePagamento,
      filteredOrcamento.subtotal,
    );
  };

  let content = [];

  if (props.data) {
    props.data.forEach((row) => {
      content.push(
        <div className="dots__menu__popup">
          {/* Ver Orcamento */}
          {auth.perm.includes("r-orc") && (
            <>
              {(row.beneficio === "Particular" ||
                row.tipoCobertura === "MISTO") &&
                row.status !== "INTERROMPIDO" &&
                (((auth.role === "Médico/Administrador" ||
                  auth.role === "Dentista") &&
                  row.medico_responsavel._id === auth.userId) ||
                  ((auth.role === "Secretária(o)" ||
                    auth.role === "Assistente") &&
                    auth.usuariosAssociados.some(
                      (medico) => medico.id === row.medico_responsavel.id,
                    ))) && (
                  <div
                    className="popOverMenu--option"
                    onClick={verOrcamento.bind(null, row.id, "Particular")}
                  >
                    <span>Gerar PDF Particular</span>
                    <FileText className="popOverMenu--option__icon" />
                  </div>
                )}

              {row.beneficio !== "Particular" &&
                row.status !== "INTERROMPIDO" &&
                (((auth.role === "Médico/Administrador" ||
                  auth.role === "Dentista") &&
                  row.medico_responsavel._id === auth.userId) ||
                  ((auth.role === "Secretária(o)" ||
                    auth.role === "Assistente") &&
                    auth.usuariosAssociados.some(
                      (medico) => medico.id === row.medico_responsavel.id,
                    ))) && (
                  <div
                    className="popOverMenu--option"
                    onClick={verOrcamento.bind(null, row.id, "SEGURADO")}
                  >
                    <span>Gerar PDF {row.instituicaoCobertura.nome}</span>
                    <FileText className="popOverMenu--option__icon" />
                  </div>
                )}

              {row.orcamentoMisto &&
                row.status !== "INTERROMPIDO" &&
                (((auth.role === "Médico/Administrador" ||
                  auth.role === "Dentista") &&
                  row.medico_responsavel._id === auth.userId) ||
                  ((auth.role === "Secretária(o)" ||
                    auth.role === "Assistente") &&
                    auth.usuariosAssociados.some(
                      (medico) => medico.id === row.medico_responsavel.id,
                    ))) && (
                  <div
                    className="popOverMenu--option"
                    onClick={verOrcamento.bind(null, row.id, "Misto")}
                  >
                    <span>Gerar PDF Misto</span>
                    <FileText className="popOverMenu--option__icon" />
                  </div>
                )}
            </>
          )}

          {auth.perm.includes("r-orc") && (
            <div
              className="popOverMenu--option"
              onClick={props.handleOpenModal.bind(null, row.id, "orcamento")}
            >
              <span>Ver Orçamento</span>
              <Eye className="popOverMenu--option__icon" />
            </div>
          )}

          {auth.perm.includes("u-orc") &&
            podeAlterarOrcamento(row) &&
            !row.nrCredencial &&
            row.beneficio !== "Particular" &&
            row.status !== "INTERROMPIDO" &&
            row.transformado &&
            (((auth.role === "Médico/Administrador" ||
              auth.role === "Dentista") &&
              row.medico_responsavel._id === auth.userId) ||
              ((auth.role === "Secretária(o)" || auth.role === "Assistente") &&
                auth.usuariosAssociados.some(
                  (medico) => medico.id === row.medico_responsavel.id,
                ))) && (
              <div
                className="popOverMenu--option"
                onClick={props.preAdicionarCredencialHandler.bind(null, row.id)}
              >
                <span>Inserir Credencial</span>
                <PlusCircle className="popOverMenu--option__icon" />
              </div>
            )}

          {auth.perm.includes("u-orc") &&
            podeAlterarOrcamento(row) &&
            row.nrCredencial &&
            row.beneficio !== "Particular" &&
            (((auth.role === "Médico/Administrador" ||
              auth.role === "Dentista") &&
              row.medico_responsavel._id === auth.userId) ||
              ((auth.role === "Secretária(o)" || auth.role === "Assistente") &&
                auth.usuariosAssociados.some(
                  (medico) => medico.id === row.medico_responsavel.id,
                ))) && (
              <div
                className="popOverMenu--option"
                onClick={props.preEditarDadosCredencialHandler.bind(
                  null,
                  row.id,
                )}
              >
                <span>Editar Dados Credencial</span>
                <Edit3 className="popOverMenu--option__icon" />
              </div>
            )}

          {auth.perm.includes("u-orc") &&
            podeAlterarOrcamento(row) &&
            row.status !== "INTERROMPIDO" &&
            (((auth.role === "Médico/Administrador" ||
              auth.role === "Dentista") &&
              row.medico_responsavel._id === auth.userId) ||
              ((auth.role === "Secretária(o)" || auth.role === "Assistente") &&
                auth.usuariosAssociados.some(
                  (medico) => medico.id === row.medico_responsavel.id,
                ))) && (
              <Popconfirm
                title="Renovação de orçamento"
                description="Confirma renovação do orçamento?"
                icon={<RefreshCw />}
                okText="Sim"
                cancelText="Não"
                onConfirm={() => props.renovarOrcamento(row.id)}
              >
                <div className="popOverMenu--option">
                  <span>Renovar Orçamento</span>
                  <RefreshCw className="popOverMenu--option__icon" />
                </div>
              </Popconfirm>
            )}

          {auth.perm.includes("u-orc") &&
            podeAlterarOrcamento(row) &&
            row.status !== "INTERROMPIDO" &&
            (((auth.role === "Médico/Administrador" ||
              auth.role === "Dentista") &&
              row.medico_responsavel._id === auth.userId) ||
              ((auth.role === "Secretária(o)" || auth.role === "Assistente") &&
                auth.usuariosAssociados.some(
                  (medico) => medico.id === row.medico_responsavel.id,
                ))) && (
              <div
                className="popOverMenu--option"
                onClick={() => handleAbrirSubstituicao(row.id)}
              >
                <span>Substituir Orçamento</span>
                <Replace className="popOverMenu--option__icon" />
              </div>
            )}

          {/* Edição de orçamento desativada: usar a Substituição de Orçamento.
              A edição alterava dente/face sem rasto financeiro e podia
              dessincronizar o plano de tratamento. */}

          {auth.perm.includes("d-orc") && row.status !== "INTERROMPIDO" && (
            <div
              className="popOverMenu--option"
              onClick={() =>
                navigate(
                  `/clientes/${row.cliente._id}/orcamentoDireto/novo/${row._id}`,
                )
              }
            >
              <span>Duplicar Orçamento</span>
              <Copy className="popOverMenu--option__icon" />
            </div>
          )}

          {auth.perm.includes("u-orc") &&
            podeAlterarOrcamento(row) && (
            <Popconfirm
              title={
                row.entregueNaClinica?.entregue
                  ? "Cancelar entrega"
                  : "Marcar como entregue"
              }
              description={
                row.entregueNaClinica?.entregue
                  ? "Tem a certeza que pretende cancelar a entrega?"
                  : "Confirma que o orçamento foi entregue na clínica?"
              }
              icon={
                row.entregueNaClinica?.entregue ? (
                  <XCircle style={{ color: "red" }} />
                ) : (
                  <ClipboardCheck />
                )
              }
              okText="Sim"
              cancelText="Não"
              onConfirm={() => props.toggleEntregaClinica(row.id)}
            >
              <div className="popOverMenu--option">
                <span>
                  {row.entregueNaClinica?.entregue
                    ? "Cancelar Entrega"
                    : "Marcar como Entregue"}
                </span>

                {row.entregueNaClinica?.entregue ? (
                  <XCircle className="popOverMenu--option__icon" />
                ) : (
                  <ClipboardCheck className="popOverMenu--option__icon" />
                )}
              </div>
            </Popconfirm>
          )}

          {/* Desativar */}
          {auth.perm.includes("d-orc") &&
            podeAlterarOrcamento(row) &&
            !row.transformado &&
            !row.terminado &&
            row.status !== "INTERROMPIDO" &&
            (((auth.role === "Médico/Administrador" ||
              auth.role === "Dentista") &&
              row.medico_responsavel._id === auth.userId) ||
              ((auth.role === "Secretária(o)" || auth.role === "Assistente") &&
                auth.usuariosAssociados.some(
                  (medico) => medico.id === row.medico_responsavel.id,
                ))) && (
              <Popconfirm
                title="Desativação de orçamento"
                description="Tem a certeza que pretende desativar o orçamento?"
                icon={<Trash2 style={{ color: "red" }} />}
                okText="Sim"
                cancelText="Não"
                onConfirm={() => props.handleDesativar(row.id, false)}
              >
                <div className="popOverMenu--option">
                  <span>Desativar</span>
                  <Trash2 className="popOverMenu--option__icon" />
                </div>
              </Popconfirm>
            )}
        </div>,
      );
    });
  }

  return (
    <>
      <TableContainer component={Paper} className="table">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead style={{ background: "#fff" }}>
            <TableRow>
              <TableCell className="tableCell tableCell--heading tableCell--heading--start">
                Código
              </TableCell>
              <TableCell className="tableCell tableCell--heading tableCell tableCell--heading--start">
                Avaliação
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Criado por
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Médico Responsável
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Cobertura
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Nº Credencial
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Data Criação
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Entregue
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Estado
              </TableCell>

              <TableCell className="tableCell tableCell--heading tableCell tableCell--heading--end">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>

          {props.data && (
            <TableBody>
              {props.data.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell className="tableCell">
                    {row.avaliacao
                      ? "OR" +
                        row.codigo +
                        "_AV" +
                        row.avaliacao?.numero +
                        "_" +
                        format(new Date(row.created_at), "yyyy")
                      : "OR" +
                        row.codigo +
                        "_DIRETO_" +
                        format(new Date(row.created_at), "yyyy")}
                    {/* Unidade onde o orçamento foi feito, e o selo de só
                        consulta ao lado dela. Os dois falam da mesma coisa —
                        de onde é e o que se pode fazer com ele — por isso
                        andam juntos, junto ao código. O selo estava lá atrás,
                        na coluna do "criado por", longe da pastilha que o
                        explica. */}
                    <BadgeUnidade estabelecimento={row.estabelecimento} />
                    <SeloSoConsulta estabelecimento={row.estabelecimento} />
                  </TableCell>

                  <TableCell
                    className="tabelCell "
                    style={{ textAlign: "left" }}
                  >
                    {auth.perm.includes("r-aval") && (
                      <Tooltip title="Ver Avaliação">
                        <Eye
                          className="icon__list"
                          onClick={props.handleOpenModal.bind(
                            null,
                            row.id,
                            "avaliacao",
                          )}
                        />
                      </Tooltip>
                    )}
                  </TableCell>

                  <TableCell className="tableCell">
                    {abreviarNome(row.criadoPor?.name)}
                  </TableCell>

                  <TableCell className="tableCell">
                    {abreviarNome(row.medico_responsavel?.name)}
                  </TableCell>

                  <TableCell className="tableCell">
                    {row.beneficio}
                    {row.orcamentoMisto ? "/Misto" : ""}
                  </TableCell>

                  <TableCell className="tableCell">
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      {row.nrCredencial ? row.nrCredencial : ""}
                      {row.beneficio !== "Particular" && (
                        <Tooltip
                          title={
                            row.envioInstituicao?.enviado && row.envioInstituicao?.dataEnvio
                              ? `Enviado a ${format(new Date(row.envioInstituicao.dataEnvio), "dd-MM-yyyy")}`
                              : "Não enviado"
                          }
                        >
                          <Send
                            size={15}
                            style={{
                              color: row.envioInstituicao?.enviado ? "green" : "#9ca3af",
                              cursor: "default",
                              flexShrink: 0,
                            }}
                          />
                        </Tooltip>
                      )}
                    </div>
                  </TableCell>

                  <TableCell className="tableCell">
                    {row.data_orcamento}
                  </TableCell>

                  <TableCell
                    className="tableCell"
                    style={{ textAlign: "center" }}
                  >
                    {row.entregueNaClinica?.entregue ? (
                      <Tooltip
                        title={`Entregue em ${format(new Date(row.entregueNaClinica.data), "dd/MM/yyyy")}`}
                      >
                        <ClipboardCheck style={{ color: "green" }} size={18} />
                      </Tooltip>
                    ) : (
                      "—"
                    )}
                  </TableCell>

                  <TableCell className="tableCell">
                    <>
                      <span
                        className={
                          row.status
                            ? "status " + row.status
                            : row.terminado
                              ? "status concluido"
                              : `${
                                  row.transformado
                                    ? "status transformado"
                                    : "status pendente"
                                }`
                        }
                      >
                        {row.status === "INTERROMPIDO"
                          ? "Interrompido"
                          : row.terminado
                            ? "Concluido"
                            : `${row.transformado ? "Transformado" : "Pendente"}`}
                      </span>
                      {props.clinica.configuracoes.configuracoes
                        .validadeOrcamentos?.ativo &&
                        row.transformado === false &&
                        row.terminado === false &&
                        differenceInDays(new Date(), new Date(row.created_at)) >
                          props.clinica.configuracoes.configuracoes
                            .validadeOrcamentos?.validade && (
                          <span
                            className="status INTERROMPIDO"
                            style={{ marginLeft: 10 }}
                          >
                            Expirado
                          </span>
                        )}
                    </>
                  </TableCell>

                  <TableCell className="tableCell">
                    <div className="tableCell__action">
                      {/* Aprovar Orcamento.
                          Só na unidade onde o orçamento foi feito: aprovar é
                          um ato comercial de quem vendeu, e é lá que o plano
                          nasce. O servidor recusa na mesma — esconder o botão
                          poupa o erro a quem nunca poderia completar a ação. */}
                      {podeAlterarOrcamento(row) &&
                        auth.perm.includes("c-plt") &&
                        !row.transformado &&
                        (((auth.role === "Médico/Administrador" ||
                          auth.role === "Dentista") &&
                          row.medico_responsavel._id === auth.userId) ||
                          ((auth.role === "Secretária(o)" ||
                            auth.role === "Assistente") &&
                            auth.usuariosAssociados.some(
                              (medico) =>
                                medico.id === row.medico_responsavel.id,
                            ))) && (
                          <Tooltip title="Aprovar">
                            <Check
                              className="icon__list"
                              onClick={props.aprovarOrcamento.bind(
                                null,
                                row.id,
                              )}
                            />
                          </Tooltip>
                        )}

                      {content[index] && (
                        <Popover
                          content={content[index]}
                          trigger="click"
                          placement="bottom"
                        >
                          <div className="dots__menu">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                          </div>
                        </Popover>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      {orcamentoSelecionado && (
        <ModalSubstituicaoOrcamento
          open={modalSubstituicaoOpen}
          onClose={handleFecharSubstituicao}
          orcamento={orcamentoSelecionado}
        />
      )}
    </>
  );
}

export default List;
